import * as React from 'react';

function SvgDotCircled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 23.98" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M22.39 6A11.78 11.78 0 0124 12a11.75 11.75 0 01-1.61 6A11.87 11.87 0 0118 22.37 11.65 11.65 0 0112 24a11.63 11.63 0 01-6-1.61A11.87 11.87 0 011.61 18 11.75 11.75 0 010 12a11.78 11.78 0 011.61-6A11.94 11.94 0 016 1.61 11.73 11.73 0 0112 0a11.75 11.75 0 016 1.61A11.94 11.94 0 0122.39 6zm-6.13-1.36A8.29 8.29 0 0012 3.5a8.33 8.33 0 00-4.27 1.14 8.48 8.48 0 00-3.09 3.09A8.29 8.29 0 003.5 12a8.29 8.29 0 001.14 4.26 8.51 8.51 0 003.09 3.1A8.32 8.32 0 0012 20.48a8.28 8.28 0 004.26-1.13 8.46 8.46 0 003.1-3.1A8.29 8.29 0 0020.5 12a8.29 8.29 0 00-1.14-4.26 8.43 8.43 0 00-3.1-3.1zm-1.43 4.53A3.84 3.84 0 0116 12a4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4 3.88 3.88 0 012.83 1.17z" />
    </svg>
  );
}

const MemoSvgDotCircled = React.memo(SvgDotCircled);
export default MemoSvgDotCircled;
